import store from "@frameworks/web/redux/store";
import { OFFERINGS_DATA, OFFERINGS_START_LOADER, OFFERINGS_STOP_LOADER, OFFERINGS_HIDE_ERROR, OFFERINGS_SET_ERROR, } from "../../interfaces/Home/iAllOfferings";
class AllOfferingsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getAllOfferings(data) {
        this.dispatch({
            type: OFFERINGS_DATA,
            payload: { data },
        });
    }
    startLoader() {
        this.dispatch({
            type: OFFERINGS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: OFFERINGS_STOP_LOADER,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: OFFERINGS_SET_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: OFFERINGS_HIDE_ERROR,
        });
    }
}
export default AllOfferingsActions;
